var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',{attrs:{"title":"绑定用户","left-arrow":"","showFooterTabBar":true},on:{"click-left":_vm.onNavBarClickLeft}},[_c('Cell',[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.doShareMiniProgram}},[_vm._v("分享小程序")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }